import { FC } from 'react';
import { IonButton } from '@ionic/react';
import { DuoPersonCirlcePlusIcon } from '../theme/Icons';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { HistoryViewModel } from '../support/HistoryViewModel';
import { CareMapState } from '../caremap/CareMapState';
import { useBreakpoints } from '../theme/useBreakpoints';

export const InviteCommunityButton: FC = () => {
    const history = useInstance(HistoryViewModel);
    const careMapState = useInstance(CareMapState);

    const mostRecentCareMap = careMapState.getMostRecentCaremap();

    const {isBelowBreakpoint} = useBreakpoints();
    const label = isBelowBreakpoint('sm') ? 'Invite' : 'Invite to Community';

    const canInvite = Boolean(mostRecentCareMap?.links.invites);

    if (!mostRecentCareMap || !canInvite) {
        return null;
    }

    return (
        <IonButton
            fill="clear"
            color="primary"
            data-id="invite-community-button"
            onClick={() => history.push(`/community/${mostRecentCareMap.careMapId}`)}
        >
            <DuoPersonCirlcePlusIcon />&nbsp;{label}
        </IonButton>
    );
};
